import { connect } from 'react-redux';
import React, { Component } from 'react';
import ApplicationPage from '../../pages/application-page/Application';

export class WrappedApplicationPage extends Component {
    render() {
        return <ApplicationPage {...this.props} nonRLClientWithRAID={true}/>;
    }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WrappedApplicationPage);
